import { BackdropTheme, SternumTheme } from '@sternum/ui';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMDarkBackdropTheme(theme: SternumTheme): Partial<BackdropTheme.BackdropTheme> {
  return {
    backdropFilterHide: '',
    backdropFilterShow: '',
    backgroundShow: 'rgba(38, 41, 49, 0.6)',
  };
}
